import { load as loadBase, init as initBase, detectMask as detectMaskBase } from './maskDetectionWorkerBase';

export default class MaskDetectionFakeWorker {
  private maskModel: any;

  public async load() {
    await loadBase();
    this.importScript('/opencv.js');
  }

  public async init(data: any) {
    this.maskModel = await initBase(data);
  }

  public async detectMask(data: any) {
    return detectMaskBase(data, this.maskModel);
  }

  private importScript(resourceUrl: string) {
    // eslint-disable-next-line
    //@ts-ignore
    if (!window.opencvjsimported) {
      const script = document.createElement('script');
      script.src = resourceUrl;
      script.async = false;
      document.body.appendChild(script);
      // eslint-disable-next-line
      //@ts-ignore
      window.opencvjsimported = true;
    }
  }
}
